import React, { useState, useEffect } from "react";
import {
    X,
    Package,
    MapPin,
    Tag,
    Shield,
    IndianRupee,
    Calendar,
    Eye,
    Image as ImageIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Pagination } from '../../src/Admin/Common';

const ProductDetailsModal = ({
    isOpen,
    onClose,
    uid,
    type,
    title = "Products",
}) => {


    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNo, setPageNO] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const getProducts = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminAuth");

            const endpoint =
                type === "cart"
                    ? "admin_cart_products"
                    : "admin_checkout_products";

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/${endpoint}/?page=${pageNo}&page_size=${perPage}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        uid,
                    }),
                }
            );

            const result = await response.json();

            if (response.ok) {
                setProducts(result?.results || []);

                setTotalItem(result?.count || 0);

                setTotalPage(
                    Math.ceil((result?.count || 0) / perPage)
                );
            }

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen && uid) {
            getProducts();
        }
    }, [isOpen, uid, pageNo, perPage]);

    useEffect(() => {
        if (!isOpen) {
            setProducts([]);
            setPageNO(1);
        }
    }, [isOpen]);
    if (!isOpen) return null;

    const getCondition = (condition) => {
        switch (condition) {
            case 1:
                return "New";
            case 2:
                return "Used";
            default:
                return "N/A";
        }
    };

    return (
        <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-[70vw] max-h-[90vh] overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between border-b px-6 py-5 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
                    <div>
                        <h2 className="text-2xl font-bold !text-white ">{title}</h2>
                        <p className="text-sm text-white/80">
                            Total Products: {totalItem || 0}
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl hover:bg-white/20 transition"
                    >
                        <X size={24} />
                    </button>
                </div>

                {/* Body */}
                <div className="overflow-y-auto max-h-[78vh] p-6 bg-gray-50">
                    {loading ? (

                        <div className="h-full min-h-[500px] flex items-center justify-center">
                            <div className="text-center">

                                <div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto"></div>

                                <p className="mt-4 text-gray-500">
                                    Loading Products...
                                </p>

                            </div>
                        </div>

                    ) : products?.length > 0 ? (
                        <div className="divide-y divide-gray-200">
                            {products.map((product) => {
                                const isAskForPrice =
                                    product?.others?.askingPriceEnable === true;

                                return (
                                    <div
                                        key={product?.uid || product?.id}
                                        className="flex items-center gap-4 p-4 hover:bg-gray-50 transition"
                                    >
                                        {/* Thumbnail */}
                                        <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden border bg-white">
                                            <img
                                                src={
                                                    product?.product_images?.[0]?.variants?.medium ||
                                                    product?.product_images?.[0]?.p_image ||
                                                    "/placeholder-product.png"
                                                }
                                                alt={product?.equip_name}
                                                className="w-full h-full object-cover"
                                                onError={(e) => {
                                                    e.target.src = "/placeholder-product.png";
                                                }}
                                            />
                                        </div>

                                        {/* Product Details */}
                                        <div className="flex-1 min-w-0">
                                            <a
                                                href={`${process.env.REACT_APP_FRONTEND_URL}/${product?.slug}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-lg font-semibold text-gray-800 hover:text-teal-600"
                                            >
                                                {product?.equip_name}
                                            </a>

                                            {product?.brand && (
                                                <p className="text-sm text-gray-500 mt-1">
                                                    Brand: {product?.brand}
                                                </p>
                                            )}
                                        </div>

                                        {/* Price */}
                                        <div className="text-right min-w-[160px]">
                                            <p className="text-xs text-gray-400">
                                                Price
                                            </p>

                                            <p className="text-xl font-bold text-teal-600">
                                                {isAskForPrice
                                                    ? "Ask For Price"
                                                    : `₹${Number(
                                                        product?.asking_price || 0
                                                    ).toLocaleString("en-IN")}`}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                            {totalItem > 0 && (
                                <Pagination
                                    total={totalItem}
                                    perPage={perPage}
                                    currPage={pageNo}
                                    prevPage={Math.max(1, pageNo - 2)}
                                    tPage={totalPage}
                                    updatePage={(e) => {
                                        const name = e.target.getAttribute("name");

                                        if (name === "prev") {
                                            if (pageNo > 1) {
                                                setPageNO(pageNo - 1);
                                            }
                                        } else if (name === "next") {
                                            if (pageNo < totalPage) {
                                                setPageNO(pageNo + 1);
                                            }
                                        } else {
                                            const page = parseInt(e.target.innerText);

                                            if (!isNaN(page)) {
                                                setPageNO(page);
                                            }
                                        }
                                    }}
                                    setCurrPage={setPageNO}
                                    setPerPage={setPerPage}
                                />
                            )}
                        </div>
                    ) : (
                        <div className="py-20 text-center">
                            <Package size={70} className="mx-auto text-gray-300" />

                            <h3 className="mt-4 text-lg font-semibold text-gray-600">
                                No Products Found
                            </h3>

                            <p className="text-gray-400 text-sm mt-1">
                                This customer has no products in the selected section.
                            </p>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default ProductDetailsModal;